import { render, staticRenderFns } from "./ChbBasicCountryDataFields.vue?vue&type=template&id=46478a8c"
import script from "./ChbBasicCountryDataFields.vue?vue&type=script&lang=js"
export * from "./ChbBasicCountryDataFields.vue?vue&type=script&lang=js"
import style0 from "./ChbBasicCountryDataFields.vue?vue&type=style&index=0&id=46478a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports